import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';

import { FlatTreeControl } from "@angular/cdk/tree";
import { MatTreeFlatDataSource, MatTreeFlattener }
  from "@angular/material/tree";
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { DashboardComponent } from '../dashboard/dashboard.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuTrigger } from '@angular/material/menu';
import { messageService } from '../message.service';
import { qmsService } from '../qms/qms.service';
import { CRComponent } from '../qms/cr/cr.component';
import { TopNavigationComponent } from '../top-navigation/top-navigation.component';
import { TopNavService } from '../top-navigation/top-navigation.service';
import { ChangeDetectorRef } from '@angular/core';

interface Family {
  name: string;
  children?: Family[];
}
let FAMILY_TREE1: Family[] = []
const FAMILY_TREE: Family[] =
  [
  ];

/** Flat node with expandable and level information */
interface ExampleFlatNode {
  expandable: boolean;
  name: string;
  level: number;
}

@Component({
  selector: 'app-left-tree',
  templateUrl: './left-tree.component.html',
  styleUrls: ['./left-tree.component.scss']
})
export class LeftTreeComponent implements OnInit {
  showLeftMenu = false;
  modulesList: Array<any>;
  enteredButton = false;
  isMatMenuOpen = false;
  isMatMenu2Open = false;
  prevButtonTrigger: { closeMenu: () => void; };

  private _transformer = (node: Family, level: number) => {
    return {
      expandable: !!node.children && node.children.length > 0,
      name: node.name,
      level: level,
    };
  };


  treeControl = new FlatTreeControl<ExampleFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.children
  );

  treenavigation(node: any) {
    debugger;
    if (node.name == "Manage Trainings") {
      this.router.navigate(['/dashboard/manageTraining']);
    } else if (node.name == "User Management") {
      this.router.navigate(['/dashboard/users']);
    } else if (node.name == "FlexiFields") {
      this.router.navigate(['/dashboard/flexfieldSetup']);
    } else if (node.name == "Quality") {
      this.router.navigate(['/dashboard/qmsSettings']);
    }
  }

  dataSource = new MatTreeFlatDataSource(
    this.treeControl, this.treeFlattener);

  constructor(private appService: AppService, private router: Router, public dashboardComponent: DashboardComponent, private cdr: ChangeDetectorRef,
    private ren: Renderer2, public message: messageService, public qmsservice: qmsService, public topNavService: TopNavService,) {
    this.dataSource.data = FAMILY_TREE;
    this.dashboardComponent.onChange.subscribe({
      next: (event: boolean) => {
        this.showLeftMenu = event;
      }
    })
    this.qmsservice.highlightBackground = null;
  }
  treeDataSource: any = [];

  oneQmsOrgImagesDetails: any = {};

  iconsString: any = "";
  hasChild = (_: number,
    node: ExampleFlatNode) => node.expandable;
  // menuList:any=[];
  //menuList:any= [];
  @ViewChild
    (TopNavigationComponent) topNavigationComponent!: TopNavigationComponent;
  trainingChilderns: any = [];
  documentChilderns: any = [];
  logsChilderns: any = [];
  businessAreaChildrens: any = [];
  ngOnInit(): void {
    this.qmsservice.highlightBackground = null;
    this.appService.getfirstmenu().subscribe((data: any) => {
      for (let o = 0; o < data.length; o++) {
        if (data[o].name == "Quality" || data[o].name == "Logs" || data[o].name == "Trainings" || data[o].name == "Documents" || data[o].name == "Business Process") {
          if (data[o].name == "Trainings") {
            this.trainingChilderns = data[o].children;
          } else if (data[o].name == "Documents") {
            this.documentChilderns = data[o].children;
          } else if (data[o].name == "Logs") {
            this.logsChilderns = data[o].children;
          }
          else if (data[o].name == "Business Process") {
            this.businessAreaChildrens = data[o].children;
          }
          data[o].children = [];
          //break;
        }
      }
      this.dataSource.data = data;
      this.treeDataSource = data;
      this.treeDataSource.push({ name: "Logout", children: [] });


    })

    this.message.activityLeftmenuList = [{
      name: "Actions",
      tooltip: "Actions"
    }, {
      name: "Documents",
      tooltip: "Documents"
    }, {
      name: "Reviewers/Approvers",
      tooltip: "Reviewers/Approvers"
    }, {
      name: "Effectiveness Check",
      tooltip: "Effectiveness Check"
    }, {
      name: "Notifications/Reminders",
      tooltip: "Notifications/Reminders",
    }, {
      name: "Extensions",
      tooltip: "Extensions"
    }, {
      name: "Dependency",
      tooltip: "Dependency"
    }];

    this.appService.getAllOrgReportImages().subscribe((orgImage: any) => {
      this.oneQmsOrgImagesDetails = orgImage;
    })
  }
  ActivityPages(firstChild: String) {
    let data: any;
    if (firstChild == "Change Request" || firstChild == "CAPA" || firstChild == "Deviation" || firstChild == "Audit") {
      data = document.getElementById('MainActivity') as HTMLElement;
    } else if (firstChild.includes("Details")) {
      data = document.getElementById('ActivityDetails') as HTMLElement;
    } else if (firstChild == "Reviewers/Approvers") {
      data = document.getElementById('ReviewApprove') as HTMLElement;
    } else if (firstChild == "Actions") {
      data = document.getElementById('Actions') as HTMLElement;
    } else if (firstChild == "Dependency") {
      data = document.getElementById('Dependency') as HTMLElement;
    } else if (firstChild == "Documents") {
      data = document.getElementById('Documents') as HTMLElement;
    } else if (firstChild == "Effectiveness Check") {
      data = document.getElementById('EffectivenessCheck') as HTMLElement;
    } else if (firstChild == "Notifications/Reminders") {
      data = document.getElementById('NotificationsReminders') as HTMLElement;
    } else if (firstChild == "Extensions") {
      data = document.getElementById('Extensions') as HTMLElement;
    } else if (firstChild == "Flexifield") {

    };

    setTimeout(() => data.scrollIntoView(), 0);
  }

  highlightBackground: any = Number;
  secondLevel(firstChild: String, idx: number) {
    this.qmsservice.highlightBackground = idx;
    this.qmsservice.showTopNav = true;
    this.message.breadcrumbData.firstLevel = firstChild;
    this.message.breadcrumbData.secondLevel = null;
    this.message.breadcrumbData.thirdLevel = null;
    this.message.breadcrumbData.fourthLevel = null;
    if (this.message.breadcrumbData.firstLevel == "Quality") {
      this.qmsservice.showTopNav = true;
      this.qmsservice.topNavModule = "Quality";
      this.topNavigationComponent.newgetcall();
    } else if (this.message.breadcrumbData.firstLevel == "Trainings") {
      this.qmsservice.showTopNav = true;
      this.qmsservice.topNavModule = "Trainings";
      this.topNavService.selectedVal = "My Trainings";
      this.topNavService.moduleChildrens = this.trainingChilderns;
      this.topNavigationComponent.subModuleSelect();
    } else if (this.message.breadcrumbData.firstLevel == 'Logs') {
      this.qmsservice.showTopNav = true;
      this.qmsservice.topNavModule = "Logs";
      this.topNavService.selectedVal = "Logs";
      this.topNavService.moduleChildrens = this.logsChilderns;
      this.topNavigationComponent.subModuleSelect();
    } else if (this.message.breadcrumbData.firstLevel == "Documents") {
      this.qmsservice.showTopNav = true;
      this.qmsservice.topNavModule = "Documents";
      this.topNavService.selectedVal = "Repository";
      this.topNavService.moduleChildrens = this.documentChilderns;
      this.topNavigationComponent.subModuleSelect();
    } else if (this.message.breadcrumbData.firstLevel == "Business Process") {
      this.qmsservice.showTopNav = true;
      this.qmsservice.topNavModule = "Business Process";
      this.topNavService.selectedVal = "Manage";
      this.topNavService.moduleChildrens = this.businessAreaChildrens;
      this.topNavigationComponent.subModuleSelect();
    } else if (this.message.breadcrumbData.firstLevel == 'Admin') {
      this.qmsservice.showTopNav = false;
    } else if (this.message.breadcrumbData.firstLevel == 'Settings') {
      this.qmsservice.showTopNav = false;
    } else if (this.message.breadcrumbData.firstLevel == 'Logout') {
      this.dashboardComponent.logout();
    } else {
      this.qmsservice.showTopNav = false;
    }

    if (this.message.breadcrumbData.firstLevel == 'My Tasks') {
      this.appService.setRouteOfMyTask("All");
      this.router.navigate(['/dashboard/MyTasks']);
    }
    if (this.message.breadcrumbData.firstLevel == 'Home') {
      this.router.navigate(['dashboard']);
    }
    // if (this.message.breadcrumbData.firstLevel == 'Logs') {
    //   this.router.navigate(['dashboard/formsAndLogs']);
    // }

    if (this.message.breadcrumbData.firstLevel == 'Dashboard') {
      this.appService.setRouteOfMyTask("All");
      this.router.navigate(['/dashboard/OneQMSDashboard']);
    }
  }
  thirdLevel(firstChild: String) {
  }
  // @ViewChild('logoutPopup', { static: true }) logoutPopup: TemplateRef<any>;
  // visibleLogoutPopupPopup: MatDialogRef<TemplateRef<any>>;
  // logout() {

  getNotification(evt: String) {
    // Do something with the notification (evt) sent by the child!
  }


  ngAfterViewInit(): void {
    this.cdr.detectChanges();
  }

  // openMyMenu(menuTrigger: MatMenuTrigger) {
  //   menuTrigger.openMenu();
  // } 
  // closeMyMenu(menuTrigger: MatMenuTrigger) {
  //   menuTrigger.closeMenu();
  // } 

}

export interface NavItem {
  displayName: string;
  iconName: string;
  route?: string;
  children?: NavItem[];
}
